window.addEventListener("popstate", function(event) {
if (window.location.hostname === "radroller.com" && window.location.pathname === "/") {
    
}
});
window.addEventListener("beforeunload", function (e) {
  $("button[aria-label='close cart']").trigger("click");
  window.SLIDECART_OPENED = function() {
   window.SLIDECART_UPDATE();
  } 
});




var myInterval = setInterval(function () {
    if($('ul.custom_product_recommendation.grid.product-grid li').length > 0){
        clearInterval(myInterval);
$('ul.custom_product_recommendation.grid.product-grid').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  infinite: true,
  prevArrow:'<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--17405055566114__featured_collection" ><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
 nextArrow:'<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--17405055566114__featured_collection"><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
       
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         infinite: true
      }
    }
   
  ]

});
}
 }, 1000);
    


$(document).click(function (e) {

  var popup = $("ul.custom_country_swicther");
  if (!$('ul.custom_country_swicther').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
    //             alert('outside'); 
    $('li.country-selected').hide();
  }
  else{
  }
});
$("body").on("click", "ul.custom_country_swicther .init", function() {
    $(this).closest("ul.custom_country_swicther").children('li:not(.init)').toggle();
});



    
var allOptions = $("ul.custom_country_swicther").children('li:not(.init)');
$("body").on("click", "ul.custom_country_swicther li:not(.init)", function() {
    allOptions.removeClass('selected');
    $(this).addClass('selected');
    $("ul.custom_country_swicther").children('.init').html($(this).html());
    allOptions.toggle();
});

$(document).ready(function(){
// setTimeout(function(){
//   if( $(".shopify-payment-button__button--branded .bold_clone").length > 0 && $(".shopify-payment-button__button--branded .bold_hidden").length  > 0){
// $(".shopify-payment-button__button--branded .bold_clone").attr("style","display:none !important;");
// }
// },2500);
  
  
$('p.custom_rating.rating-count.caption span').click(function () {
    
 $('html, body').animate({ scrollTop: $('.jdgm-widget.jdgm-review-widget.jdgm--done-setup-widget').offset().top }, 2000);
});
  
$("details#Details-HeaderMenu-1").click(function(e){
  $(this).removeAttr('open','');
});

$("div#MegaMenu-Content-1").mouseleave(function(){
    $('details#Details-HeaderMenu-1').removeAttr('open','');
  $('svg.meag_menu_drop_down_icon').css('display','block');
     $('svg.custom_mega_menu_drop_up_icon').css('display','none');
});
  $("h1.header__heading").mouseenter(function(){
    $('details#Details-HeaderMenu-1').removeAttr('open','');
});
    $("h1.header__heading img").mouseenter(function(){
    $('details#Details-HeaderMenu-1').removeAttr('open','');
});
    $(" a.announcement-bar__link.link.link--text.focus-inset").mouseenter(function(){
    $('details#Details-HeaderMenu-1').removeAttr('open','');
      
      
});
  $('a.header__heading-link.link.link--text.focus-inset').mouseenter(function(){
 $('svg.meag_menu_drop_down_icon').css('display','block');
     $('svg.custom_mega_menu_drop_up_icon').css('display','none');
});
  $('a.announcement-bar__link.link.link--text.focus-inset.animate-arrow').mouseenter(function(){
 $('svg.meag_menu_drop_down_icon').css('display','block');
     $('svg.custom_mega_menu_drop_up_icon').css('display','none');
});
$('a.cstm_lsit.header__menu-item.list-menu__item.link.link--text.focus-inset').mouseenter(function(){
 $('svg.meag_menu_drop_down_icon').css('display','block');
     $('svg.custom_mega_menu_drop_up_icon').css('display','none');
});
$("details.mega-menu").mouseenter(function(){
    $(this).attr('open','');
  $('svg.meag_menu_drop_down_icon').css('display','none');
     $('svg.custom_mega_menu_drop_up_icon').css('display','block');
});
  $("a.cstm_lsit.header__menu-item").mouseenter(function(){
    $('details#Details-HeaderMenu-1').removeAttr('open','');
    //alert(1);
});
 


// $("details.mega-menu").mouseenter(function(){
//     $(this).attr('open','');
// });
// $("details.mega-menu").mouseleave(function(){
//     $(this).removeAttr('open','');
// });
 /*********************************************************/ 
  var myInterval1 = setInterval(function () {
 if($('.product__media img').length > 0){
        clearInterval(myInterval1);    
$('.product__media img ').each(function() {
 var getting =  $(this).attr('alt');
   // console.log(getting);
    var cstm ='side-view';
    if(getting == cstm){
var get_html = $(this).attr('srcset');
      //  console.log(get_html);
         $('.side_view_image img').attr("src", get_html).show();
          $('.side_view_image h2').html(getting);
    var side_view=  $('.side_view_image h2').css("text-transform","capitalize");
    }else{
//console.log('no');
    }

});
  }
         }, 1000);
});



  $(document).ready(function(){
    var myInterval2 = setInterval(function () {
        if($('.custom_product_grid li').length > 0){
        clearInterval(myInterval2);
$('ul.custom_product_grid').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  infinite: true,
  prevArrow:'<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--17405055566114__featured_collection" ><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
 nextArrow:'<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--17405055566114__featured_collection"><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
       
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         infinite: true
      }
    }
   
  ]

});
        }
       }, 1000);
    
  
  
  $('.accordion-content.open').show();
// $(".accordion-toggle").eq(0).addClass('active');
  $('.accordion-toggle').on('click', function(e) {
    e.preventDefault();
    $(".accordion-toggle").not($(this)).removeClass('active');
    $(this).next('.accordion-content').slideToggle();
    // $(".accordion-toggle.active").eq(0).removeClass('active');
    // $(".accordion-toggle.active").removeClass("active");
    if($(this).hasClass("active")){
      $(this).removeClass("active");
      $("a.main-title-jtpl.no-child-menu").removeClass("active-menu-child");
    }else{
      $(this).addClass("active");
    }
    
    $(this).parent().siblings().find('.accordion-content').slideUp();
  });
  }); 



 $(document).ready(function(){
   mobileSwitcher();
   $('span.deferred-media__poster-button.motion-reduce').click(function(){
   $(" .video-section.isolate h2").css({"display":"none"});

      });
 });
function mobileOnlySlider() {
$('.custom_collection_mobile').slick({
slidesToShow: 1,
slidesToScroll: 1,
arrows: true,
prevArrow:'<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--17405055566114__featured_collection" ><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
nextArrow:'<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--17405055566114__featured_collection"><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
infinite: true
});
}
if(window.innerWidth < 768) {
mobileOnlySlider();
}

function mobileSwitcher(){
   if(window.innerWidth < 990) {
     if($("#mobile-selector-jtpl").length == 0){
         var selc = $(".custom_bloc_country_selector").html();   
         var newDiv = $('<div>').attr('id', 'mobile-selector-jtpl').addClass('custom_bloc_country_selector');    
          // Append the new div as the first child of the header__icons element
          $('.header__icons').prepend(newDiv); $("#mobile-selector-jtpl").append(selc);
     }
   }else{
      $("#mobile-selector-jtpl").remove();
   }
}
$(window).resize(function(e){  
            mobileSwitcher();  
    if(window.innerWidth < 768) {
        if(!$('.custom_collection_mobile').hasClass('slick-initialized')){
            mobileOnlySlider();
        }

    }else{
        if($('.custom_collection_mobile').hasClass('slick-initialized')){
            $('.custom_collection_mobile').slick('unslick');
        }
    }
});




function desktopOnlySlider() {
$('.custom_product_grid').slick({
slidesToShow: 1,
slidesToScroll: 1,
arrows: true,
  
prevArrow:'<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--17405055566114__featured_collection" ><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
nextArrow:'<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--17405055566114__featured_collection"><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
infinite: true
});
}

if(window.innerWidth > 750) {
desktopOnlySlider();
}

$(window).resize(function(e){
    if(window.innerWidth > 750) {
        if(!$('.custom_product_grid').hasClass('slick-initialized')){
            desktopOnlySlider();
        }

    }else{
        if($('.custom_product_grid').hasClass('slick-initialized')){
            $('.custom_product_grid').slick('unslick');
        }
    }
});


// function mobileOnlySliderCstm() {

//  //var interval = setInterval(function() {
//   var myInterval = setInterval(function () {
//     if ($('ul.custom_product_recommendation').length > 0) {
//       //alert('hii');
// $('ul.custom_product_recommendation').slick({
// slidesToShow: 1,
// slidesToScroll: 1,
// arrows: true,
// prevArrow:'<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--17405055566114__featured_collection" ><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
// nextArrow:'<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--17405055566114__featured_collection"><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
// infinite: true
// });
//  //clearInterval(myInterval);
//  //}, 3000); 
//     }
//     }, 1000);
// }

// if(window.innerWidth < 768) {
// mobileOnlySliderCstm();
// }

// $(window).resize(function(e){
//     if(window.innerWidth < 768) {
//         if(!$('ul.custom_product_recommendation').hasClass('slick-initialized')){
//                 if ($('ul.custom_product_recommendation').length > 0) {
//       //alert('hii');
// $('ul.custom_product_recommendation').slick({
// slidesToShow: 1,
// slidesToScroll: 1,
// arrows: true,
// prevArrow:'<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--17405055566114__featured_collection" ><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
// nextArrow:'<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--17405055566114__featured_collection"><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
// infinite: true
// });

//     }
//         }

//     }else{
//         if($('ul.custom_product_recommendation').hasClass('slick-initialized')){
//             $('ul.custom_product_recommendation').slick('unslick');
          
//         }
//     }
// });


$(document).ready(function(){
  $("body").on("click", ".sub-accordion-jtpl", function(e) {
  e.preventDefault();
   var $this = $(this);
   if($(this).hasClass("sub-accordion-active")){
        $(this).removeClass("sub-accordion-active");
        $(".sub-accordion-body-jtpl").removeClass("sub-accordion-active");
        $(".sub-accordion-jtpl").removeClass("sub-accordion-active");
   }else{
        $(".sub-accordion-jtpl").removeClass("sub-accordion-active");     
        $(".sub-accordion-body-jtpl").not($(this).next()).removeClass("sub-accordion-active");
        $(this).addClass("sub-accordion-active");
        $(this).parents(".sub-menu-jtpl").find(".sub-accordion-body-jtpl").addClass("sub-accordion-active");          
   } 
 });
 var myInterval1 = setInterval(function () {
if($('.announcement-bars-jtpl').length > 0 && $(".announcement-bars-items").length > 1){
   clearInterval(myInterval1);
  $('.announcement-bars-jtpl').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    adaptiveHeight:true,
     prevArrow:'<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left"><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#fff" stroke-width="3"/></svg></button>',
    nextArrow:'<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right"><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#fff" stroke-width="3"/></svg></button>',
  
  });
}else{
  $('.announcement-bars-jtpl').addClass("size-0");
  // if($('.announcement-bars-items').length == 0){
  //   $(".announcement-bar").hide();
  // }
}

   }, 1000);   
  
 $('.testimonial_outer_main').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow:'<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Slide left" aria-controls="Slider-template--17405055566114__featured_collection" ><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
 nextArrow:'<button type="button" class="slider-button slider-button--next" name="next" aria-label="Slide right" aria-controls="Slider-template--17405055566114__featured_collection"><svg xmlns="http://www.w3.org/2000/svg" id="Group_346" data-name="Group 346" width="64" height="64" viewBox="0 0 64 64"><g id="Ellipse_4" data-name="Ellipse 4" fill="none" stroke="#238dc1" stroke-width="3"><circle cx="32" cy="32" r="32" stroke="none"/><circle cx="32" cy="32" r="30.5" fill="none"/></g><path id="Path_932" data-name="Path 932" d="M4440.168,1791.132l12.795,12.966-12.795,11.768" transform="translate(-4411.272 -1771.499)" fill="none" stroke="#238dc1" stroke-width="3"/></svg></button>',
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
       
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
 });
  /*collection page accordion js start */
  if($("body").hasClass("custom--collection")){
  var main_collection = $(".jtpl-collection-accordions").attr("data-collection");
        // console.log(main_collection);
       $("ul.accordion-content li a").each(function(){
        var text = $(this).attr("data-url"); 
         //   console.log(text);
         // console.log("text---" + text);
           
        if(main_collection.indexOf(text) > -1){
          // console.log("indexOfText" + text);
          $("a.main-title-jtpl.no-child-menu").removeClass("active-menu-child");
            $(this).addClass("active-collection-jtpl");
          $("ul.accordion-content").removeClass("open");
          $(".main-title-jtpl.accordion-toggle").removeClass("active");
          $("a.active-collection-jtpl").parents("ul.accordion-content").addClass("open");
          $(".accordion-content.open").parent("li").find(".main-title-jtpl.accordion-toggle").addClass("active");
        }
       });

    /*************** when accordion-toogle added  *******************/
       $(".desktop-view-collection-menu-jtpl a.main-title-jtpl.accordion-toggle").each(function(){
        var url = $(this).attr("collection-url"); 
         //   console.log(url);
         // console.log("text---" + url);
           
        if(main_collection.indexOf(url) > -1){
          // console.log("indexOfText" + url);
          $("a.main-title-jtpl.no-child-menu").removeClass("active-menu-child");
          $(".desktop-view-collection-menu-jtpl ul.accordion-content").removeClass("open");
          $(".desktop-view-collection-menu-jtpl .main-title-jtpl.accordion-toggle").removeClass("active");
            $(this).addClass("active");
            $(this).parents("li").find("ul.accordion-content").addClass("open");
        }
       });

    /************** when no child menu   ***************/
    $("a.main-title-jtpl.no-child-menu").each(function(){
        var urlCollection = $(this).attr("collection-url"); 
         //   console.log(url);
         // console.log("text---" + urlCollection);
      // console.log("main_collection---" + main_collection);
           
        if(main_collection == urlCollection){
          // console.log("Main_collection====" + urlCollection);
          // $("a.main-title-jtpl.no-child-menu").removeClass("active-menu-child");
          $(this).addClass("active-menu-child");
        }
       });
    
    
  }
    /*collection page accordion js end */
  /************ cart drawer start ***************/
    $("body").on("click",".slidecarthq button" , function(){
   setTimeout(function() {   var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => { 
        let cart = data.item_count;
          $(".cart-count").text(cart);
         $(".cart-count-bubble span[aria-hidden='true']").text(cart);
         $(".cart-count-bubble").attr("cart-item", cart);
         });
     }, 1050);
 });
  
  $("body").on("click",".slidecarthq-overlay" , function(){
    if($(this).hasClass("open")){
      var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => { 
        let cart = data.item_count;
        $(".cart-count").text(cart);
         $(".cart-count-bubble span[aria-hidden='true']").text(cart);
         $(".cart-count-bubble").attr("cart-item", cart);
        // console.log("Cart value:", cart); 
        // console.log(data); 
         });
    }   
 });
   /************ cart drawer end **************/
  // var habdleDisocunts = setInterval(handleDiscFumct,1000);
  // function handleDiscFumct(){
  //   if($('#slidecarthq .discount-box').length > 0){
  //       $('#slidecarthq .footer.sticky-footer').prepend($('#slidecarthq .discount-box'));
  //     clearInterval(habdleDisocunts);
  //   } 
  // }

  /************ collection page mobileview filter accordion start **************/
$(document).on('click', function(e) {
    if (!$(e.target).closest('.accordion-title, .accordion-paragraph').length) {
        $('.accordion-paragraph').hide();
        $('.accordion-title').removeClass('active-filter');
    }
});

$('.accordion-title').on('click', function() {
    var $menu = $(this).next('.accordion-paragraph');
    $('.accordion-paragraph').not($menu).slideUp(300);
    $('.accordion-title').not(this).removeClass('active-filter');
    if ($menu.is(':visible')) {
        $menu.slideUp(300); 
        $(this).removeClass("active-filter");
    } else {
        $menu.slideDown(300); 
        $(this).addClass("active-filter");
    }
});
  

  /************ collection page mobileview filter end **************/
});
// $(document).ready(function(){
//  var symbol = $("iframe.custom_youtube")[0].src.indexOf("?") > -1 ? "&" : "?";
//   //modify source to autoplay and start video
//   $("iframe.custom_youtube")[0].src += symbol + "autoplay=1";

// });

//   $(document).ready(function(){
// const range = document.getElementById("range");


// const scale = (num, in_min, in_max, out_min, out_max) => {
//   return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
// };

// range.addEventListener("input", (e) => {
//   const value = +e.target.value;
//   const label = e.target.nextElementSibling;
//   const rangeWidth = getComputedStyle(e.target).getPropertyValue("width");
//   const labelWidth = getComputedStyle(label).getPropertyValue("width");
//   // remove px
//   const numWidth = +rangeWidth.substring(0, rangeWidth.length - 2);
//   const numLabelWidth = +labelWidth.substring(0, labelWidth.length - 2);
//   const max = +e.target.max;
//   const min = +e.target.min;
//   const left =
//     value * (numWidth / max) -
//     numLabelWidth / 2 +
//     scale(value, min, max, 10, -10);
//   label.style.left = `${left}px`;
//   label.innerHTML = value;
// });
//   });
  //as noted in addendum, check for querystring exitence




